import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { Drawer as RSDrawer } from "rsuite";
import { Button } from "..";
function Drawer(props) {
    const { open, setOpen, title, children, onClose } = props;
    const placement = props.placement ?? "right";
    const { Header, Body } = RSDrawer;
    const handleClose = () => {
        onClose ? onClose() : setOpen(false);
    };
    return (_jsxs(RSDrawer, { placement: placement, open: open, onClose: handleClose, children: [_jsxs(Header, { children: [_jsx("h5", { style: { margin: 4 }, children: title }), _jsx(Button, { onClick: handleClose, className: "close-button", type: "error", icon: "xmark" })] }), _jsx(Body, { children: children })] }));
}
export default Drawer;
